module.exports = __webpack_public_path__ + "img/xero-connect-blue.b73e4ac5.png";